import { IOWObject } from "OW.Remoting/Remoting/DataTypes/IOWObject";
import { IRecordIdentification } from "OW.Remoting/Remoting/DataTypes/RecordIdentification";

export class FormResult {
    public readonly resultType: FormResultType;
    public readonly resultValue: IRecordIdentification | IOWObject;

    constructor(resultValue: IRecordIdentification | IOWObject, formResultType: FormResultType = FormResultType.ok) {
        this.resultValue = resultValue;
        this.resultType = formResultType;
    }
}

export enum FormResultType {
    ok,
    cancel,
}
